var React = require('react');

function NextPage (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M10.7057391,9.46448467 C10.5154857,9.27987732 10.5109087,8.97599259 10.695516,8.78573915 C10.8801234,8.59548571 11.1840081,8.59090865 11.3742615,8.77551601 L14.4289031,11.7395061 C14.6232215,11.9280578 14.6232215,12.239923 14.4289031,12.4284747 L11.3742615,15.3924648 C11.1840081,15.5770722 10.8801234,15.5724951 10.695516,15.3822417 C10.5109087,15.1919882 10.5154857,14.8881035 10.7057391,14.7034961 L13.4053606,12.0839904 L10.7057391,9.46448467 Z","fill":"currentColor","fillRule":"nonzero","stroke":"currentColor","strokeWidth":"1","transform":"translate(-16.000000, -14.000000) translate(6.000000, 6.000000)"}));
}

NextPage.defaultProps = {"width":"5px","height":"8px","viewBox":"0 0 5 8","version":"1.1"};

module.exports = NextPage;

NextPage.default = NextPage;
